import React, { useState, useEffect } from 'react';
import { useCookies } from "react-cookie";
import {MDBContainer} from "mdb-react-ui-kit";

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());

    // eslint-disable-next-line no-continue
    if (a === b) continue;

    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

const AppBuildVersion = () => {
  const [cookies, setCookie] = useCookies(['appUser']);
  const [currentBuildVersion, setAppVersion] = useState(cookies.appUser?.appVersion || '0.0.0');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAppVersion = async () => {
      let retries = 0;
      const maxRetries = 3;

      while (retries < maxRetries) {
        try {
          const response = await fetch(`appVersion.json?v=${Date.now()}`, { // Cache busting
            cache: "no-store",
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
          if (!response.ok) {
            throw new Error('Unable to load application build version details');
          }
          const data = await response.json();
          const shouldForceRefresh = semverGreaterThan(data.appVersion, currentBuildVersion);
          if (shouldForceRefresh) {
            console.log(`We have a new version - ${data.appVersion}. Should force refresh`);
            setCookie('appUser', { appVersion: data.appVersion }, {
              path: '/',
            });
            setAppVersion(data.appVersion);
            setTimeout(() => { // Delay before reload
              window.location.reload();
            }, 1000);
          } else {
            console.log(`You already have the latest version - ${data.appVersion}. No cache refresh needed.`);
          }
          setAppVersion(data.appVersion);
          return; // Exit the loop on success
        } catch (err) {
          console.error('Error fetching app version:', err);
          setError(err.message);
          retries++;
          await new Promise(resolve => setTimeout(resolve, 1000)); // Delay before retry
        }
      }
      console.error("Max retries reached, version check failed");
    };
    fetchAppVersion();
  }, [currentBuildVersion, setCookie]);

  if (error) {
    return <small>Error: {error}</small>;
  }

  return (
      <MDBContainer fluid className="text-end pt-3">
        <small>Build: {currentBuildVersion}</small>
      </MDBContainer>
  );
};

export { semverGreaterThan };

export default AppBuildVersion;